// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#landing-footer[data-v-368be5a3]{padding-top:170px;padding-bottom:170px}.footer-text[data-v-368be5a3]{text-align:center;font-family:ClashDisplay-Regular;font-style:normal;font-weight:600;font-size:64px;line-height:76px;letter-spacing:-1px}@media only screen and (max-width:959px){.footer-text[data-v-368be5a3]{font-size:50px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
